import { getDomainName } from "../helpers/helpers";
import { Dependencies } from "../interfaces/dependencies-types";

import DependenciesInjector from '../helpers/dependencies-injector';
import { OptionsService } from './options-service';
import { ObfClientSettings } from "src/interfaces/obf-client-settings.interface";

export class ClientCookieService implements Dependencies {

    private optionsService: OptionsService;
    private obfClientSettings: ObfClientSettings;
    private cookieDomain = '';
    private isSameDomain = false;

    async initialize() {
        this.optionsService = await DependenciesInjector.getRegistered('OptionsService') as OptionsService;
        this.obfClientSettings = this.optionsService.getObfClientSettings();

        this.cookieDomain = getDomainName(location.hostname);
        this.isSameDomain = getDomainName(this.obfClientSettings.accounts_url) === getDomainName(this.obfClientSettings.main_url);
    }

    /**
     * 
     * @param cookieName 
     * @param value 
     * @param expire unix timestamp 
     */
    setCookie(cookieName: string, value: string, expire?: number) {

        const date: any = new Date();
        
        if (expire) {
            date.setTime(expire * 1000);
        } else {
            date.setTime(date.getTime() + (2 * 60 * 60 * 1000));
        }
        
        if ( getDomainName(location.hostname).indexOf('locahost') === -1 ) {
            if (this.isSameDomain && cookieName?.indexOf('user-login') > -1) {
                document.cookie = `${cookieName}=${value};expires=${date.toUTCString()};path=/; SameSite=Strict; Secure;`;
            } else {
                document.cookie = `${cookieName}=${value};expires=${date.toUTCString()};path=/; domain=.${this.cookieDomain}; SameSite=None; Secure;`;
                document.cookie = `_${cookieName}=${value};expires=${date.toUTCString()};path=/; domain=.${this.cookieDomain}; SameSite=Lax; Secure;`;
            }
        } else {
            // set cookie on localhost
            let domainName = getDomainName(location.hostname);
            document.cookie = `${cookieName}=${value};expires=${date.toUTCString()};path=/; domain=.${domainName}; SameSite=None;`;
        }
    }

    // getCookie(cookieName: string) {
    //     var name = cookieName + "=";
    //     var ca = document.cookie.split(';');
    //     for (var i = 0; i < ca.length; i++) {
    //         var c = ca[i];
    //         while (c.charAt(0) == ' ') {
    //             c = c.substring(1);
    //         }
    //         if (c.indexOf(name) == 0) {
    //             return c.substring(name.length, c.length);
    //         }
    //     }

    //     return "";
    // }

    getCookie(cookieName) {
        var cookies = [];
        var name = cookieName + "=";
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                cookies.push(c.substring(name.length, c.length));
            }
        }
        
        // Handle old created cookies, find old one and delete it then returns new one
        if (cookies?.length > 1 && cookieName?.indexOf('campaign_') > -1) {
            const date: any = new Date('Thu, 01 Jan 1970 00:00:01 GMT');
            document.cookie = `${cookieName}="";expires=${date.toUTCString()};path=/; SameSite=Strict; Secure;`;
            cookies.shift();
            return cookies[cookies.length - 1];
        } else if (cookies?.length === 1) {
            return cookies[cookies.length - 1];
        }        
            
        return '';
    }

    removeCookie(cookieName: string) {
        const date: any = new Date('Thu, 01 Jan 1970 00:00:01 GMT');

        if (this.getCookie(cookieName) || this.getCookie('_' + cookieName)) {
            if (this.isSameDomain && cookieName?.indexOf('user-login') > -1) {
                document.cookie = `${cookieName}="";expires=${date.toUTCString()};path=/; SameSite=Strict; Secure;`;
            } else {
                document.cookie = `${cookieName}="";expires=${date.toUTCString()};path=/; domain=.${this.cookieDomain}; SameSite=None; Secure;`;
                document.cookie = `_${cookieName}="";expires=${date.toUTCString()};path=/; domain=.${this.cookieDomain}; SameSite=Lax; Secure;`;
            }
        }
    }
}
